import { MAX_FAVOURITES } from '../constants/FavouritesConstants';

const byDisplayOrderAsc = (a, b) => a.display_order - b.display_order;
const accntClassRegEx = /account-(?<index>\d+)/;

export const removeFavouriteFromAccounts = ({ accountList, id }) =>
  accountList
    .filter((a) => a.id !== id)
    .map((a, index) => ({
      ...a,
      display_order: index + 1,
    }));

export const canAddFavourite = (accountList) =>
  accountList.length < MAX_FAVOURITES;

export const addFavouriteToAccounts = ({ accountList, account }) =>
  accountList.find((acc) => acc.id === account.id)
    ? accountList
    : [
        ...accountList,
        {
          ...account,
          display_order:
            accountList.length >= 1
              ? accountList[accountList.length - 1].display_order + 1
              : 1,
        },
      ];

export const buildFavouriteRequestFromList = (accountList) =>
  accountList
    .map((a) => ({ id: a.id, display_order: a.display_order }))
    .sort(byDisplayOrderAsc);

export const reorderAccounts = ({ reorderedIds, accountList }) =>
  accountList
    .map((a) => {
      const reorderedAcc = reorderedIds.find((x) => x.id === a.id);
      return {
        ...a,
        display_order: reorderedAcc
          ? reorderedAcc.display_order
          : a.display_order,
      };
    })
    .sort(byDisplayOrderAsc);

export const sortByDisplayOrder = (accountList) => {
  const newList = accountList.slice();
  return newList.sort(byDisplayOrderAsc);
};

export const updateAccountAtIndex = ({
  accountList = [],
  id,
  accountUpdates,
}) => {
  const accountIndex = accountList.findIndex((a) => a.id === id);
  if (accountIndex !== -1) {
    return [
      ...accountList.slice(0, accountIndex),
      {
        ...accountList[accountIndex],
        ...accountUpdates,
      },
      ...accountList.slice(accountIndex + 1),
    ];
  }
  return accountList;
};

const buildNewAccountDetails = (accountDetails) => ({
  accountDetails: {
    ...accountDetails,
    balances: undefined,
  },
  balances: accountDetails.balances || [],
});

export const updateFavouriteDetails = ({
  accountList = [],
  accountDetails = {},
}) => {
  return updateAccountAtIndex({
    accountList,
    id: accountDetails.id,
    accountUpdates: buildNewAccountDetails(accountDetails),
  });
};

export const updateSelectedAccountDetails = ({
  selectedAccount = {},
  accountDetails = {},
}) => {
  return selectedAccount.id === accountDetails.id
    ? {
        ...selectedAccount,
        ...buildNewAccountDetails(accountDetails),
      }
    : selectedAccount;
};

export const updateFavouriteDetailsError = ({
  id,
  accountList = [],
  accountDetails = {},
}) => {
  return updateAccountAtIndex({
    accountList,
    id,
    accountUpdates: {
      accountDetails,
    },
  });
};

export const updateSelectedAccountDetailsError = ({
  selectedAccount,
  accountDetails = {},
}) => {
  return selectedAccount.id === accountDetails.id
    ? {
        ...selectedAccount,
        accountDetails,
      }
    : selectedAccount;
};

export const wrapAccountIndex = (index) => {
  let modIndex = index % 10;
  return modIndex === 0 ? 10 : modIndex;
};

const getNewIndexForColourTypes = (pickerColours) => {
  if (pickerColours.length > 0) {
    const match =
      pickerColours[pickerColours.length - 1].accntClass.match(accntClassRegEx);
    if (match && match.groups && match.groups.index) {
      const index = match.groups.index;
      return Number(index) + 1;
    } else {
      return 1;
    }
  } else {
    return 1;
  }
};

export const appendColourTypeEntry = ({ pickerColours, id }) => {
  let index = getNewIndexForColourTypes(pickerColours);
  return [
    ...pickerColours,
    {
      accntId: id,
      accntClass: `account-${wrapAccountIndex(index)}`,
    },
  ];
};

export const setShowIconOnAccount = ({ accountList = [], id, value }) =>
  updateAccountAtIndex({
    accountList,
    id,
    accountUpdates: {
      showIcon: value,
    },
  });

export const performRenameAccounts = ({ accounts, renamedAccounts }) => {
  return accounts.map((account) => {
    let renamedAccount = renamedAccounts.find((a) => a.id === account.id);
    if (renamedAccount) {
      return {
        ...account,
        metadata: {
          display_name: renamedAccount.display_name,
        },
        displayName: renamedAccount.display_name,
      };
    }
    return account;
  });
};
